import type { PaginatedItemsResponse } from '@/types/Response';
import type { LabelValue } from '@/types/Type';

import type {
  LotFacets,
  LotSpecs,
} from '@strana-artw/realty';

export type OrderingValue = LabelValue;
export type CollectionOrdering = Array<OrderingValue>;

export type SendType = 'pdf' | 'digital';

export interface CollectionRequestParams {
  search?: string;
  ordering?: string;
  page?: number;
  bookingId?: number;
}

export interface CollectionRawLot {
  pk: number;
  area: number;
  price: number;
  fullFinalPrice: number;
  originalPrice: number;
  rooms: number;
  plan: string;
  features: { name: string }[];
  specialOffers: { name: string }[];
  project: {
    name: string;
    slug: string | null;
    isReplacePrice: boolean;
  };
  building: {
    name: string;
  };
  status: number;
  profitbaseBookedUntilDate: string;
}

export interface SentCollection {
  id: number;
  title: string;
  type: SendType;
  client?: {
    surname: string;
    name: string;
    patronymic: string | null;
    phone: string;
  };
  managerFio: string;
}

export interface SentCollectionItem {
  profitbase_id: number;
  comment: string;
}

export interface CurrentSentCollection extends SentCollection {
  items: Array<SentCollectionItem>;
}

export type SentCollectionResponseData = PaginatedItemsResponse<SentCollection>;

export interface CollectionFacets {
  facets: LotFacets;
}

export interface CollectionSpecs {
  specs: LotSpecs;
}

export const COLLECTION_TYPES = {
  sends: 'sends',
  manager: 'manager',
} as const;

export type CollectionType = keyof typeof COLLECTION_TYPES;
